import { get } from './axios'
const getFatianshiTokenByLoacl = function () {
  const token = localStorage.getItem('fatianshi_token') || ''
  return token
}
const setFatianshiToken = function (value) {
  localStorage.setItem('fatianshi_token', value)
}

const getFatianshiTokenByBackend = function () {
  const url = '/base/tool/fatianshi/getToken'
  return get(url)
    .then(res => {
      console.log('法天使token', res)
      if (res.code == 0) {
        setFatianshiToken(res.data)
      }
    })
}

export {
  getFatianshiTokenByLoacl,
  setFatianshiToken,
  getFatianshiTokenByBackend
}



// WEBPACK FOOTER //
// ./src/libs/fatianshi.js